module.exports = __webpack_public_path__ + "img/NEF_checkbox_active.59f15a85.svg";